module.exports = __webpack_public_path__ + "img/water.dd4b02de.png";